import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { RetrieveBookingStartupStepDefinition } from "../RetrieveBooking/RetrieveBookingStartup";
import { upcomingPastBookingStartupFlowDefinition } from "../UpcomingPastBooking/UpcomingPastBookingStartup";
import { afterSaleBookingInitStepDeclaration } from "./Steps/AfterSaleBookingInit";
import { AfterSaleBookingTransition } from "./Transition/AfterSaleBookingTransition";
import { AfterSaleUpcomingTransition } from "./Transition/AfterSaleUpcomingTransition";

export const afterSalesBookingStartupFlow = new FlowDefinition("AfterSalesBookingFlow");

afterSalesBookingStartupFlow.addStep(afterSaleBookingInitStepDeclaration);
afterSalesBookingStartupFlow.addStep(upcomingPastBookingStartupFlowDefinition);
afterSalesBookingStartupFlow.addStep(RetrieveBookingStartupStepDefinition);

afterSalesBookingStartupFlow.addLink("AfterSaleBookingInit_Step", "UpcomingPastBookingFlow");
afterSalesBookingStartupFlow.addLink("UpcomingPastBookingFlow", "RetrieveBookingFlow");
afterSalesBookingStartupFlow.addLink("RetrieveBookingFlow", "UpcomingPastBookingFlow");

afterSalesBookingStartupFlow.addTransition(AfterSaleBookingTransition, "AfterSaleBookingInit_Step");
afterSalesBookingStartupFlow.addTransition(AfterSaleUpcomingTransition, "UpcomingPastBookingFlow");
afterSalesBookingStartupFlow.addTransition(AfterSaleBookingTransition, "RetrieveBookingFlow");

afterSalesBookingStartupFlow.setStartStep("AfterSaleBookingInit_Step");